import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import i18n from '@/lang'
import dayjs from 'dayjs'
import SvgIcon from 'vue-svgicon'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import "@/styles/normalize.min.css"
import '@/styles/common.scss'
import '@/styles/element-variables.scss'
import '@/styles/index.scss'
import '@/directives'
import '@/icons/components'
import '@/plugins/element-ui'
// import "@/components/WfComponents/index.js"
import '@/permission'
import '@/utils/error-log'
import '@/config/filter'
import 'core-js/stable'; // 引入core-js来填补ES6+特性
import 'regenerator-runtime/runtime'; 
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'

dayjs.locale('zh-cn')
Vue.prototype.$dayjs = dayjs

Vue.use(
  SvgIcon, {
    tagName: 'svg-icon',
    defaultWidth: '1em',
    defaultHeight: '1em',
  },
  ElementUI
)
Vue.use(Viewer)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App)
}).$mount('#app')